import React, { useEffect, useState } from 'react';
import { XIcon, ShoppingBag } from 'lucide-react';
const purchases = [{
  name: 'Sarah M.',
  location: 'Austin, TX'
}, {
  name: 'Jessica L.',
  location: 'New York, NY'
}, {
  name: 'Emily R.',
  location: 'Los Angeles, CA'
}, {
  name: 'Amanda C.',
  location: 'Chicago, IL'
}, {
  name: 'Rachel K.',
  location: 'Miami, FL'
}, {
  name: 'Chloe T.',
  location: 'Denver, CO'
}, {
  name: 'Megan B.',
  location: 'Seattle, WA'
}, {
  name: 'Lauren S.',
  location: 'Atlanta, GA'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 6000);
    };
    const interval = setInterval(showPopup, 18000);
    setTimeout(showPopup, 4000);
    return () => clearInterval(interval);
  }, []);
  return <>
      {visible && <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 z-50 animate-slide-in flex justify-center sm:justify-end pointer-events-none" data-id="element-183" data-mp="22mf3kxtgu8zh">
          <div className="bg-white border-2 border-brand-gold shadow-[0_0_20px_rgba(212,175,55,0.4)] rounded-lg p-2.5 pr-8 max-w-[300px] w-full relative overflow-hidden pointer-events-auto" data-id="element-184" data-mp="1sqbxxhzens7s">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-gold via-brand-rose to-brand-gold" data-id="element-185" data-mp="2ler3ldwncy6g"></div>

            <button onClick={() => setVisible(false)} className="absolute top-1.5 right-1.5 text-brand-taupe/50 hover:text-brand-taupe transition-colors" data-id="element-186" data-mp="2ge3c6r4iafbp">
              <XIcon className="w-4 h-4" data-id="element-187" data-mp="151aphuqkoh2i" />
            </button>

            <div className="flex items-center gap-3" data-id="element-188" data-mp="10yw2cyfvev5f">
              <div className="w-10 h-10 rounded-full bg-brand-rose/10 flex items-center justify-center shrink-0 border border-brand-rose/30" data-id="element-189" data-mp="10xcmva21go4p">
                <ShoppingBag className="w-5 h-5 text-brand-rose" data-id="element-190" data-mp="17emh8bqyt9c0" />
              </div>
              <div className="leading-tight" data-id="element-191" data-mp="shnfv5mpicpz">
                <p className="font-bold text-brand-taupe text-sm" data-id="element-192" data-mp="sgluo8bz89uj">
                  {currentPurchase.name}
                </p>
                <p className="text-[11px] text-brand-taupe/70 font-semibold" data-id="element-193" data-mp="xevq8k1m5cgo">
                  from {currentPurchase.location}
                </p>
                <p className="text-xs text-brand-rose font-bold mt-0.5" data-id="element-194" data-mp="ogk1yoo7yqre">
                  just purchased DANCE READY™
                </p>
              </div>
            </div>
          </div>
        </div>}
    </>;
}